<template>
  <button class="getCode" v-bind:class="{disabled: counter > 0}" 
          v-bind:disabled="counter > 0"
          @click="startCounter">
      {{counter === 0 ? '获取验证码' : `( ${counter} s)`}}
  </button>
</template>

<script>
export default {
	name:"counter",
  props: ['count'],
  data() {
    return {
      counter: 0,
      interval: null
    }
  },
  methods: {
    startCounter() {
      console.log(this.count)
      if (this.count) {
        this.counter = 60
        this.interval = setInterval(() => {
          this.counter--
          if (this.counter <= 0) {
            clearInterval(this.interval)
          }
        }, 1000)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/global/counter/index.vue